import type { ReactNode } from 'react'
import { useClubContext } from '@/context/ClubContext'

/**
 * Приглашение выбрать клуб — для роли без своего клуба (super_admin и
 * кросс-клубные support/manager из Help). Раздел за этим гейтом привязан к
 * конкретному клубу, поэтому без выбранного показывает подсказку, а не пустые
 * таблицы. Сотрудника клуба гейт пропускает: его клуб известен из токена.
 */
export function ClubGate({ children }: { children: ReactNode }): React.JSX.Element {
  const { needsClub } = useClubContext()
  if (!needsClub) return <>{children}</>
  return (
    <div className="placeholder" style={{ marginTop: 24 }}>
      <div className="placeholder__mark">🏛</div>
      <div className="badge">Выбор клуба</div>
      <div>
        Выберите клуб в шапке — этот раздел привязан к конкретному клубу и без него данных не
        покажет.
      </div>
    </div>
  )
}
